// ── Shared Profile Constants ──
// Used by ProfileSettings.jsx and ProfileOnboarding.jsx

export const GENDER_OPTIONS = [
  { value: "MALE", label: "Masculino" },
  { value: "FEMALE", label: "Feminino" },
  { value: "PREFER_NOT_TO_SAY", label: "Prefiro não dizer" },
];

export const CIVIL_STATE_OPTIONS = [
  { value: "SINGLE", label: "Solteiro(a)" },
  { value: "MARRIED", label: "Casado(a)" },
  { value: "DIVORCED", label: "Divorciado(a)" },
  { value: "WIDOWED", label: "Viúvo(a)" },
];

export const CHILDREN_OPTIONS = [
  { value: "true", label: "Possui filhos" },
  { value: "false", label: "Não possui filhos" },
];

export const IA_PROFICIENCY_OPTIONS = [
  { value: "NONE", label: "Nenhuma" },
  { value: "BASIC", label: "Básico" },
  { value: "INTERMEDIATE", label: "Intermediário" },
  { value: "ADVANCED", label: "Avançado" },
];

export const SENIORITY_OPTIONS = [
  { value: "JUNIOR", label: "Júnior" },
  { value: "PLENO", label: "Pleno" },
  { value: "SENIOR", label: "Sênior" },
];

export const STATES = [
  { value: 'AC', label: 'Acre' },
  { value: 'AL', label: 'Alagoas' },
  { value: 'AP', label: 'Amapá' },
  { value: 'AM', label: 'Amazonas' },
  { value: 'BA', label: 'Bahia' },
  { value: 'CE', label: 'Ceará' },
  { value: 'DF', label: 'Distrito Federal' },
  { value: 'ES', label: 'Espírito Santo' },
  { value: 'GO', label: 'Goiás' },
  { value: 'MA', label: 'Maranhão' },
  { value: 'MT', label: 'Mato Grosso' },
  { value: 'MS', label: 'Mato Grosso do Sul' },
  { value: 'MG', label: 'Minas Gerais' },
  { value: 'PA', label: 'Pará' },
  { value: 'PB', label: 'Paraíba' },
  { value: 'PR', label: 'Paraná' },
  { value: 'PE', label: 'Pernambuco' },
  { value: 'PI', label: 'Piauí' },
  { value: 'RJ', label: 'Rio de Janeiro' },
  { value: 'RN', label: 'Rio Grande do Norte' },
  { value: 'RS', label: 'Rio Grande do Sul' },
  { value: 'RO', label: 'Rondônia' },
  { value: 'RR', label: 'Roraima' },
  { value: 'SC', label: 'Santa Catarina' },
  { value: 'SP', label: 'São Paulo' },
  { value: 'SE', label: 'Sergipe' },
  { value: 'TO', label: 'Tocantins' },
];

export const PURPOSE_QUESTIONS_ORDER = [
  "FUTURE_PLANS",
  "CAREER_GOALS",
  "IMPORTANT_CAUSES",
  "HOBBIES",
  "STRENGTHS_AND_WEAKNESSES",
  "INSPIRATIONS",
];

export const PURPOSE_QUESTION_LABELS = {
  FUTURE_PLANS: "Qual evolução pessoal e profissional quer viver nos próximos 12 meses?",
  CAREER_GOALS: "Como é a empresa ideal pra você? E que tipo de líder te inspira?",
  IMPORTANT_CAUSES: "O que te move e em que você acredita? No que investe tempo além do trabalho?",
  HOBBIES: "Conte um desafio marcante da sua trajetória, algo que te dá orgulho.",
  INSPIRATIONS: "O que atrapalha sua performance? Já recebeu sugestões de melhoria?",
  STRENGTHS_AND_WEAKNESSES: "Qual seu superpoder? O que mais elogiam em você?",
};
